import React from 'react';


// Translations
import translate from '../Translate.js';

class SignIn extends React.Component {
  constructor() {
    super();
    this.handleLoginInput = this.handleLoginInput.bind(this);
    this.login = this.login.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  componentWillMount() {
    this.state = {
      username: null,
      password: null
    }
  }

  handleLoginInput() {
    this.setState({
      username: this.username.value,
      password: this.password.value
    })
  }

  login() {
    this.props.store.SessionStore.login(this.state.username, this.state.password, this.handleLogin);
  }

  handleLogin() {
    this.props.routing.push('/');
  }

  render() {
    const { translation } = this.props;

    return(
      <div className="pane__content">
        <h1 className="pane__title">{translation.heading}</h1>
        <form onSubmit={(e) => this.props.checkValidity(e, this.login)} noValidate>
          <fieldset>
            <ul className="fields">
              <li>
                <label className="meta" htmlFor="signup-username">{translation.username}</label>
                <input type="text" id="signup-username" placeholder={translation.username} required aria-required="true" onChange={this.handleLoginInput}  ref={(input) => {this.username = input}} />
              </li>
              <li>
                <label className="meta" htmlFor="signup-password">{translation.password}</label>
                <input type="password" id="signup-password" placeholder={translation.password} required aria-required="true" onChange={this.handleLoginInput} ref={(input) => {this.password = input}} />
              </li>
            </ul>
          </fieldset>

          <button className="btn" type="submit">{translation.sign_in}</button>
        </form>
      </div>
    )
  }
}

export default translate('SignIn')(SignIn);


// WEBPACK FOOTER //
// ./src/app/components/Account/SignIn.js